export const defaultConfig = {
    PLATFORM: process.env.REACT_APP_PLATFORM || 'sef',
    LOCATION: process.env.REACT_APP_LOCATION || 'us',
    VERSION: process.env.REACT_APP_VERSION || '1.0',
    SUB_ADMIN_PLATFORM: process.env.REACT_APP_SUB_ADMIN_PLATFORM || 7
}